import { createCanvas } from "@/libs/canvas"

export const createTexture = (
  gl: WebGL2RenderingContext,
  {
    flipY,
    filtering = gl.LINEAR,
  }: { flipY?: boolean; filtering?: WebGL2RenderingContext["NEAREST" | "LINEAR"] } = {},
) => {
  const tex = gl.createTexture()

  gl.bindTexture(gl.TEXTURE_2D, tex)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filtering)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filtering)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)

  if (flipY) gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true)

  gl.bindTexture(gl.TEXTURE_2D, null)

  return tex
}

export const createTextureFromSource = async (
  gl: WebGL2RenderingContext,
  imageSource: ImageData,
): Promise<{ texture: WebGLTexture; width: number; height: number }> => {
  const width = imageSource.width
  const height = imageSource.height

  const texture = gl.createTexture()
  if (!texture) throw new Error("Failed to create texture")
  gl.bindTexture(gl.TEXTURE_2D, texture)
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true)

  if (imageSource instanceof ImageData) {
    gl.texImage2D(
      gl.TEXTURE_2D,
      0,
      gl.RGBA,
      width,
      height,
      0,
      gl.RGBA,
      gl.UNSIGNED_BYTE,
      imageSource.data,
    )
  } else {
    const tempCanvas = createCanvas(width, height)
    const tempCtx = tempCanvas.getContext("2d")
    if (!tempCtx) throw new Error("Failed to get 2D context")
    tempCtx.drawImage(imageSource as CanvasImageSource, 0, 0, width, height)
    const imageData = tempCtx.getImageData(0, 0, width, height)
    gl.texImage2D(
      gl.TEXTURE_2D,
      0,
      gl.RGBA,
      width,
      height,
      0,
      gl.RGBA,
      gl.UNSIGNED_BYTE,
      imageData.data,
    )
  }

  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)

  return { texture, width, height }
}
